module.exports = __webpack_public_path__ + "img/stand_boluo_tender_cut.918bfb22.png";